/**
 * Width of 2 columns in form
 */
export const WIDTH_2_COL = 1136;

/**
 * Color for danger text
 */
export const TEXT_COLOR_DANGER = '#ff4d4f';
export const APPLICATION_TYPES = [
  'VIREMENT',
  'EXTENSION',
  'PROPOSAL_REVISION',
  'WITHDRAWAL',
  'REPORT_SUBMISSION',
];

export const ENUM_APPLICATION_TEAM_MEMBER_TYPES = {
  PL: 'Project Leader',
  RCPL: 'RCPL',
  COPL: 'Co-PL',
  MEMBER: 'Team Member',
};

export const ENUM_SORT_ORDER = {
  ascend: 'asc',
  descend: 'desc',
};

export const ENUM_PROJECT_APPLICATION_STATUS = {
  ALL: 'All',
  ACTIVE: 'Active',
  DRAFT: 'Draft',
  PENDING: 'Pending Endorsement',
  APPROVED: 'Endorsed',
  OVERDUE: 'Overdue',
  // DELETED: 'Deleted',
  WITHDRAWN: 'Withdrawn',
};

export const ENUM_RESEARCH_RELATED = {
  YES: 'Yes',
  NO: 'No',
  NA: 'N/A',
};

export const ENUM_APPLICATION_STATUS = {
  DRAFT: 'Draft',
  PENDING: 'Pending Approval',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  VOIDED: 'Voided',
  DELETED: 'Deleted',
};

export const ENUM_REPORT_TYPE = {
  PROGRESS_REPORT: 'Progress Report',
  COMPLETION_REPORT: 'Completion Report',
};

export const ENUM_PROJECT_STATUS_CONTROL_TYPE = {
  PREPARATION: 'PREPARATION',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  WITHDRAWN: 'WITHDRAWN',
  TERMINATED: 'TERMINATED',
};

export const ENUM_EMAIL_CATEGORIES = {
  PROJECT_INFORMATION: 'Project Information',
  CHANGE_OF_PROJECT_PROPOSAL: 'Change of Project Proposal',
  REPORT_SUBMISSION_REMINDER: 'Report Submission Reminder',
  PROJECT_VIREMENT: 'Project Virement',
  PROJECT_EXTENSION: 'Project Extension',
  PROJECT_WITHDRAWAL: 'Project Withdrawal',
  PROJECT_TERMINATION: 'Project Termination',
  CLOSING_OF_ACCOUNT: 'Closing of Account',
  FSLTC_ANNUAL_REPORT: 'F/SLTC Annual Report',
  PROJECT_APPLICATION: 'Project Application',
};

export const ENUM_FACULTY_CONTROL_TYPE = {
  FACULTY: 'Faculty',
  SCHOOL: 'School',
  NAU: 'NAU',
};

export const ENUM_RECIPIENT_TYPE = {
  ROLE: 'Role',
  PL: 'PL',
  APPROVER: 'Approver',
};

export const ENUM_ROLE_RECIPIENT_LEVEL = {
  ALL: 'All',
  FACULTY: 'Faculty',
  DEPARTMENT: 'Department',
};

export const PLACEHOLDER = {
  PLEASE_ENTER: 'please enter',
  PLEASE_SELECT: 'please select',
};

export const PROPTYPES_SUBFOLDER = [
  'PROFILE',
  'VIREMENT',
  'REPORT_SUBMISSION',
  'PROPOSAL_REVISION',
  'EXTENSION',
  'WITHDRAWAL',
];

export const ENUM_PROPOSAL_REVISION_CHANGES_INCLUDED = {
  TEAM: 'Team member or leadership change',
  BUDGET: 'Budget plan change',
};

export const ENUM_DEPARTMENT_CONTROL_TYPE = {
  FACULTY: 'faculty',
  DEPARTMENT: 'department',
  SCHOOL: 'school',
  NAU: 'NAU',
};

export const VALUE_ENUM_APPLICATION_STATUS = {
  ALL: { text: 'All', status: 'Default' },
  PENDING: { text: 'Pending Approval', status: 'Processing' },
  REJECTED: { text: 'Rejected', status: 'Error' },
  APPROVED: { text: 'Approved', status: 'Success' },
  VOIDED: { text: 'Voided', status: 'Default' },
};
